module.exports = __webpack_public_path__ + "img/brightness-high.119291ba.svg";